module.exports = __webpack_public_path__ + "img/news8-4.3a926e5f.png";